<script lang="ts" setup>
import AHeader from '../common/AHeader.vue'
import VersionCheck from '../common/VersionCheck.vue'
const debugEnabled = !!(import.meta.env.VITE_DEBUG as number)
</script>

<template>
  <AHeader />
  <div class="container py-12 h-100 d-flex flex-column">
    <slot />
  </div>
  <div v-if="debugEnabled" class="container mt-24 d-flex flex-wrap gap-12">
    <RouterLink :to="{ name: 'debug-input' }" class="btn btn-danger">Debug input events</RouterLink>
    <RouterLink :to="{ name: 'debug-scanner' }" class="btn btn-danger"
      >Debug scanner focus</RouterLink
    >
    <RouterLink :to="{ name: 'debug-padding' }" class="btn btn-danger">Debug padding</RouterLink>
  </div>
  <VersionCheck />
</template>
